const Joi = require('@hapi/joi');

module.exports = Joi.object({
  name: Joi.string().required().max(200).label('Name').trim(),
  displayName: Joi.string().max(200).label('Display name').required(),
  numRaces: Joi.number().required().min(3).max(10).label('Number of races'),
  numberOfPlayers: Joi.number()
    .required()
    .min(4)
    .max(500)
    .label('Number of players'),
  startBalance: Joi.number().required().min(50).max(150).label('Start balance'),
  bettingCurrency: Joi.string().valid('£', '$', '€', '☘️').required(),
}).options({ stripUnknown: true });
